// Component: Component Champions Card
// Description:

function initComponentChampionsCard(context = document) {
  const blockContainers = context.querySelectorAll('.gb-block-container');
  if (!blockContainers.length) return;

  blockContainers.forEach(blockContainer => {
    componentChampionsCardHeadingHeightAdjustment(blockContainer);
  });
}

function initObserveGbTabs(context = document) {
  const gbTabsList = context.querySelectorAll('.gb-tabs');
  if (!gbTabsList.length) return;

  gbTabsList.forEach(gbTabs => {
    const gbTabsListItems = gbTabs.querySelector('.gb-tabs__items');
    if (!gbTabsListItems || gbTabsListItems.championsTabsObserver) return; // Avoid duplicate observers.

    const obs = new MutationObserver(mutations => {
      let gbTabsPanelOpen = null;

      for (const m of mutations) {
        if (m.type === 'attributes' && m.attributeName === 'class') {
          const node = m.target;
          if (
            node.classList &&
            node.classList.contains('gb-tabs__item') &&
            node.classList.contains('gb-tabs__item-open')
          ) {
            gbTabsPanelOpen = node;
          }
        }
      }

      if (gbTabsPanelOpen) {
        // Wait a couple frames so styles/animations settle before measuring.
        requestAnimationFrame(() => {
          requestAnimationFrame(() => {
            const blockContainer = gbTabsPanelOpen.closest('.gb-block-container') || gbTabsPanelOpen;
            componentChampionsCardHeadingHeightAdjustment(blockContainer);
          });
        });
      }
    });

    obs.observe(gbTabsListItems, {
      subtree: true,
      attributes: true,
      attributeFilter: ['class'],
    });

    gbTabsListItems.championsTabsObserver = obs;
  });
}

// Run on frontend
document.addEventListener('DOMContentLoaded', () => {
  initComponentChampionsCard();
  initObserveGbTabs(); // <-- new

  // Re-run on resize (debounced)
  let resizeTimeout;
  window.addEventListener('resize', () => {
    clearTimeout(resizeTimeout);
    resizeTimeout = setTimeout(() => {
      initComponentChampionsCard();
    }, 150); // Delay
  });
});

function componentChampionsCardHeadingHeightAdjustment(blockContainer) {
  // Only proceed if the container actually has a champions card component
  const hasChampionsCard = !!blockContainer.querySelector('.gb-component-champions-card');
  if (!hasChampionsCard) return;

  // Collect headings and subheadings within this block container
  const componentChampionsCardHeading = blockContainer.querySelectorAll('.gb-text.gb-component-champions-card__heading');
  const componentChampionsCardSubheading = blockContainer.querySelectorAll('.gb-text.gb-component-champions-card__subheading');

  // If neither exists, nothing to do
  if (!componentChampionsCardHeading.length && !componentChampionsCardSubheading.length) return;

  // Reset heights before measuring (natural height)
  componentChampionsCardHeading.forEach(el => { el.style.height = ''; });
  componentChampionsCardSubheading.forEach(el => { el.style.height = ''; });

  // Measure max heights
  let componentChampionsCardHeadingMaxHeight = 0;
  let componentChampionsCardSubheadingMaxHeight = 0;

  componentChampionsCardHeading.forEach(el => {
    const h = el.offsetHeight;
    if (h > componentChampionsCardHeadingMaxHeight) componentChampionsCardHeadingMaxHeight = h;
  });

  componentChampionsCardSubheading.forEach(el => {
    const h = el.offsetHeight;
    if (h > componentChampionsCardSubheadingMaxHeight) componentChampionsCardSubheadingMaxHeight = h;
  });

  // Apply uniform heights within this container
  if (componentChampionsCardHeadingMaxHeight > 0) {
    componentChampionsCardHeading.forEach(el => {
      el.style.height = `${componentChampionsCardHeadingMaxHeight}px`;
    });
  }

  if (componentChampionsCardSubheadingMaxHeight > 0) {
    componentChampionsCardSubheading.forEach(el => {
      el.style.height = `${componentChampionsCardSubheadingMaxHeight}px`;
    });
  }
}